import { render, staticRenderFns } from "./HotDealDetail.vue?vue&type=template&id=4d0c8993&"
import script from "./HotDealDetail.vue?vue&type=script&lang=js&"
export * from "./HotDealDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports